import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import InputMask from 'react-input-mask';
import ExclusionEdit from "./ExclusionEdit";

interface IFormProps {
  type: object
}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string,
  type: object,
  excludes: object,
  boxDisplay: string,
}
export default class TypeEdit extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: true,
      spinner: 'none',
      type: this.props.type,
      excludes: {},
      boxDisplay: 'collapsed-box',
    }
  }



  private dataHandleSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin + '/reservatio/beallitasok/typeUpdate/' + this.props.type['id']);
    ajax.doPost('edit_type_' + this.props.type['id'], true).then((response) => {
      swal({
        title: response.message,
        icon: response.status,
      });
    })
  }

  private boxCollapse(){
    this.setState({
      boxDisplay: this.state.boxDisplay == '' ? 'collapsed-box' : ''
    })
  }
  

  public render() {
    let type = this.state.type

    return (
      <div className={"box " + this.state.boxDisplay}>
        <div className="box-header">
          <h3 className="box-title">{this.props.type['name']}</h3> 
          <div className="box-tools pull-right">
            <button type="button" className="btn btn-box-tool" data-widget="collapse" style={{marginTop: '0px'}} onClick={() => this.boxCollapse()}>
              <i className={this.state.boxDisplay == ''?"fa fa-minus":"fa fa-plus"}></i>
            </button>
          </div>  
        </div>
        <div className="box-body" style={{position: 'relative', display: this.state.boxDisplay == ''?'block':'none'}}>
          <div className="spinner-fill" style={{display: this.state.spinner}}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          { this.state.boxDisplay == '' ?
          <div>
            <div className="col-md-6">
              <form id={'edit_type_' + this.props.type['id']} onSubmit={(e) => this.dataHandleSubmit(e)}>
                <label>NYITVATARTÁS:</label>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    HÉTFŐ:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_monday'] ?? ''} mask="99:99" className="form-control" name="open_monday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_monday'] ?? ''} mask="99:99" className="form-control" name="close_monday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    KEDD:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_tuesday'] ?? ''} mask="99:99" className="form-control" name="open_tuesday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_tuesday'] ?? ''} mask="99:99" className="form-control" name="close_tuesday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    SZERDA:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_wednesday'] ?? ''} mask="99:99" className="form-control" name="open_wednesday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_wednesday'] ?? ''} mask="99:99" className="form-control" name="close_wednesday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    CSÜTÖRTÖK:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_thursday'] ?? ''} mask="99:99" className="form-control" name="open_thursday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_thursday'] ?? ''} mask="99:99" className="form-control" name="close_thursday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    PÉNTEK:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_friday'] ?? ''} mask="99:99" className="form-control" name="open_friday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_friday'] ?? ''} mask="99:99" className="form-control" name="close_friday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    SZOMBAT:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_saturday'] ?? ''} mask="99:99" className="form-control" name="open_saturday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_saturday'] ?? ''} mask="99:99" className="form-control" name="close_saturday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="form-group">
                  <div className="col-12 col-sm-12 col-md-4" style={{lineHeight: '34px',textAlign: 'right', padding: '0px'}}>
                    VASÁRNAP:
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 plebania_from_date">
                    <InputMask defaultValue={type['open_sunday'] ?? ''} mask="99:99" className="form-control" name="open_sunday" placeholder="-tól" />
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <InputMask defaultValue={type['close_sunday'] ?? ''} mask="99:99" className="form-control" name="close_sunday" placeholder="-tól" />
                  </div>
                  <div style={{clear:'both'}}></div>
                </div>
                <div className="">
                  <button type="submit" className="btn btn-success btn-sm pull-right">Mentés</button>
                </div>
              </form>
            </div>
            <div className="col-md-6">

              <label>KIZÁRT DÁTUMOK:</label>

              <ExclusionEdit type={type} />
            </div>
          </div>
          :
          <></>
          }
        </div>
      </div>
    )
  }
}